import { IGetFileAsBlobEndpoint } from "./GetFileAsBlobEndpoint";
import { IGetFilesEndpoint } from "./GetFilesEndpoint";
import { IUploadFileEndpoint } from "./UploadFileEndpoint";


export class FilesRepository implements IFilesRepository
{
    private getFilesEndpoint: IGetFilesEndpoint;
    private uploadFileEndpoint: IUploadFileEndpoint;
    private getFileAsBlobEndpoint: IGetFileAsBlobEndpoint;

    constructor(
        getFilesEndpoint: IGetFilesEndpoint,
        uploadFileEndpoint: IUploadFileEndpoint,
        getFileAsBlobEndpoint: IGetFileAsBlobEndpoint
    )
    {
        this.getFilesEndpoint = getFilesEndpoint;
        this.uploadFileEndpoint = uploadFileEndpoint;
        this.getFileAsBlobEndpoint = getFileAsBlobEndpoint;
    }

    public getFiles(path: string): Promise<IFile[]>
    {
        return this.getFilesEndpoint.execute(path);
    }

    public getFileAsBlob(path: string, suppressErrorPopup?: boolean): Promise<Blob>
    {
        return this.getFileAsBlobEndpoint.execute(path, suppressErrorPopup ?? false);
    }

    public uploadFile(fileData: FormData, pathValue: string, processAsMap: boolean): Promise<void>
    {
        return this.uploadFileEndpoint.execute(fileData, pathValue, processAsMap);
    }

}
export interface IFilesRepository 
{
    getFiles(name: string): Promise<IFile[]>;
    getFileAsBlob(path: string, suppressErrorPopup?: boolean): Promise<Blob>;
    uploadFile(fileData: FormData, pathValue: string, processAsMap: boolean ): Promise<void>;
}

export interface IFile
{
    name: string;
    path: string;
    lastModified: string;
    createdAt: string;
    size: string;
}
